module.exports = __webpack_public_path__ + "img/COM-A-1-III.d8bc1ce5.png";